import React from "react";


export function PublicationsSection() {
  return (
    <div className="grid gap-8 md:grid-cols-2">
      <div className="md:col-span-2 space-y-6">
        <h2 className="text-2xl font-semibold">Publications</h2>
        <p className="text-muted-foreground">
          Grab the opportunity to publish in leading journals. Selected papers will be published in peer-reviewed
          international journals.
        </p>

        <ul className="text-sm text-muted-foreground grid gap-1">
          <li>• Journal of Orthopaedics Biomaterials and Biosystems</li>
          <li>• Critical Reviews in Biomedical Engineering</li>
          <li>• Journal of Prosthetics and Orthotics (JPO)</li>
          <li>• Journal of Applied Biology &amp; Biotechnology</li>
          <li>• Trends in Biomaterials and Artificial Organs</li>
        </ul>

        <div className="rounded-lg border border-gray-400 p-4">
          <h3 className="font-medium">Major Areas for Publication</h3>
          <ul className="text-sm text-muted-foreground grid gap-1 mt-2">
            <li>• Cell-based studies and biomaterial–cell interactions</li>
            <li>• Tissue Engineering &amp; Regenerative Medicine</li>
            <li>• Nanotechnology in Biomedical Applications</li>
            <li>• Drug Delivery Systems, Therapeutics &amp; Nanomedicine</li>
            <li>• Artificial Organs, Prosthetics &amp; Orthotics</li>
            <li>• Biomechanics, Gait Analysis &amp; Rehabilitation</li>
            <li>• Biomedical Imaging &amp; Signal Processing</li>
            <li>• Computational Modeling &amp; Simulation</li>
            <li>• Biomaterials design, synthesis &amp; characterization</li>
            <li>• Clinical translation &amp; healthcare applications</li>
            <li>• Medical Devices &amp; Instrumentation</li>
            <li>• General Biochemistry &amp; Molecular Biology</li>
            <li>• Applied Research in Biological Sciences</li>
            <li>• Plant Science &amp; Medicinal Plants</li>
            <li>• Biotechnology &amp; Bioinformatics</li>
            <li>• Microbiology &amp; Food Science; Agronomy &amp; Crop Science</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
